export const getSimulationHashmap = (res: SimulationApiResponseObj[]) => {
    const generateSimulationsHashmap = (prev: SimulationsHashmap, curr: SimulationApiResponseObj) => {
        return {
            ...prev,
            [curr.createdBy]:
                prev[curr.createdBy] && prev[curr.createdBy][curr.status]
                    ? {
                          ...prev[curr.createdBy],
                          [curr.status]: {
                              total: prev[curr.createdBy][curr.status].total + 1,
                              simulationIds: [...prev[curr.createdBy][curr.status].simulationIds, curr.id]
                          }
                      }
                    : {
                          // if the current simulation was created by a new user and status is new
                          // create a new status object
                          ...prev[curr.createdBy],
                          [curr.status]: {
                              total: 1,
                              simulationIds: [curr.id]
                          }
                      }
        };
    };

    const simulationsObj = res.reduce(generateSimulationsHashmap, {} as SimulationsHashmap);
    return simulationsObj;
};
